// extracted by mini-css-extract-plugin
module.exports = {"result":"ClassificationResult_result_3SJ7E"};